import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import { checkHealthScoreStatus, highlightColumnColor } from '../../utils/dashboardCalculations';

class playerHealthScore extends Component {
	componentDidMount() {}

	render() {
		const { player } = this.props;
		// const highlightColor = highlightColumnColor(player.team_gaming_score, 'cardSpread');
		const highlightColor = highlightColumnColor(player?.gaming_score, 'cardSpread', 'playerhealth', false)
		const healthStatus = player && player?.gaming_score ? checkHealthScoreStatus(player.gaming_score, null, 'player') : '';

		return (
			<div className={`cardSpreadDiv ${this.props.sportsName === 'nfl' && (player.injury_status === "Out" || player.injury_status === "Probable" || player.injury_status === "Questionable") ? 'injured-main' : '' }`}>
				<Row className="cardSpreadRow">
					<Col lg={12} className={`cardHighlight ${highlightColor}`}>
						<div className='cardSpreadDiv'>
							<h4 className='cardSpread'>
								{/* {
									this.props.sportsName === 'nfl' &&
									(
										(player.injury_status === 'Out' || player.injury_status === 'Probable' || player.injury_status === 'Questionable') ? (
											<>
												<span className='cardSpreadNoBetText'>INJURED</span>
												<div className='d-flex justify-content-center align-items-center quad_tag'>
													<span className='cardSpreadNumberTeam'>{player?.injury_body_part}</span>
													<span className='cardSpreadNumberTeam'>Did Not Practice</span>
												</div>
											</>
										) : (
											<>
												<span className='cardSpreadNoBetText'>HEALTHY</span>
											</>
										)
									)
								}
								{
									this.props.sportsName !== 'nfl' &&
									(
										<>
											<span className='cardSpreadNoBetText'>Injury Risk</span>
											<span className='cardSpreadNumberTeam'>{player.irc_total} %</span>
										</>
									)
								} */}
								<span className={`playerInfoProgressValue`}>{healthStatus.status}</span>

							</h4>
						</div>
					</Col>
				</Row>
			</div>
		);
	}
}

export default playerHealthScore;
